import React from 'react';
import { string } from 'prop-types';
import moment from 'moment';
import _ from 'lodash';

import RowContainer from '../common/RowContainer';
import PdfIcon from '../icons/PdfIcon';
import ExcelIcon from '../icons/ExcelIcon';
import LinkRow from '../common/LinkRow';
import Row from '../common/Row';

const ReportsListRow = ({ name, url, generatedDate, typeFile, state }) => (
  <RowContainer>
    {url ? <LinkRow href={url} target="_blank">{name}</LinkRow> : <Row>{name}</Row>}
    <Row>{moment(generatedDate).format('D-M-YYYY h:mm')}</Row>
    <Row>
      {typeFile === 'PDF' ? <PdfIcon /> : <ExcelIcon />}
    </Row>
    <Row>{_.capitalize(state)}</Row>
  </RowContainer>
);

ReportsListRow.propTypes = {
  name: string.isRequired,
  generatedDate: string.isRequired,
  typeFile: string.isRequired,
  state: string.isRequired,
  url: string
};

export default ReportsListRow;



// WEBPACK FOOTER //
// ./src/components/report/ReportsListRow.js